import React, { ComponentType } from 'react';
import { Box } from '@wix/design-system';
import TemplateCardImage from '../TemplateCardImage';
import s from '../TemplateCard.module.scss';
import { TemplateGalleryCard } from '../../../../types/index';

export interface LoadedTemplateCardProps {
  template: TemplateGalleryCard;
  index: number;
  hover: boolean;
  setHover: React.Dispatch<React.SetStateAction<boolean>>;
  overlayContent?: React.ReactElement;
  loadedCardClassName?: string;
  mediaContainerClassName?: string;
  CardInfo: ComponentType<{
    template: TemplateGalleryCard;
    hovered: boolean;
    showFeatures?: boolean;
  }>;
  showFeatures?: boolean;
}

const TemplateLoadedCard = ({
  template,
  index,
  hover,
  setHover,
  overlayContent,
  loadedCardClassName,
  mediaContainerClassName,
  CardInfo,
  showFeatures,
}: LoadedTemplateCardProps) => {
  return (
    <Box
      direction="vertical"
      verticalAlign="middle"
      dataHook="desktop-card"
      className={
        loadedCardClassName
          ? `${s.template} ${loadedCardClassName}`
          : s.template
      }
    >
      <TemplateCardImage
        imageSource={template.media?.longThumbnail?.url}
        description={template.media?.longThumbnail?.description ?? ''}
        index={index}
        animatedPreview={template.media?.animatedPreview}
        hovered={hover}
        overlayContent={overlayContent}
        mediaContainerClassName={mediaContainerClassName}
      />
      <div onMouseEnter={() => setHover(true)}>
        <CardInfo
          template={template}
          hovered={hover}
          showFeatures={showFeatures}
        />
      </div>
    </Box>
  );
};

export default TemplateLoadedCard;
